import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import Styles from "./Quote.module.css";

/**
 * Quote — a standalone attributed quote (e.g. a founder / origin callout).
 * Nothing else in the library renders one: the only testimonial treatment is
 * embedded in FeaturedService's card row. A panel with the accent-bar idiom
 * (the IntroColumns callout, scaled up), quote-scale type, and a tracked cite.
 *
 * @typedef {import("@prismicio/client").Content.QuoteSlice} QuoteSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<QuoteSlice>} QuoteProps
 * @param {QuoteProps}
 */
const Quote = ({ slice: { primary } }) => {
	return (
		<section
			className={Styles.wrapper}
			data-theme={primary?.dark_theme ? "dark" : "light"}>
			<div className={Styles.container} data-contain="true">
				<figure className={Styles.block}>
					<blockquote className={Styles.quote}>
						<PrismicRichText field={primary?.quote} />
					</blockquote>
					{isFilled.keyText(primary?.cite) && (
						<figcaption className={Styles.cite}>{primary?.cite}</figcaption>
					)}
				</figure>
			</div>
		</section>
	);
};

export default Quote;
